export const ONGOING_STATUSES = [
  "ACCEPTED",
  "SCHEDULED",
  "DELIVERY_REJECTED",
  "DELIVERED",
  "ON_GOING",
  "REJECTED"
];
